import * as React from "react";
const SvgFiRrFeedbackReview = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-feedback-review_svg__a)">
      <path
        fill="#062147"
        d="m23.763 6.597-1.577 1.285.652 1.987a.666.666 0 0 1-.997.769l-1.836-1.196L18.2 10.65a.668.668 0 0 1-1.007-.754l.627-2.011-1.585-1.29a.666.666 0 0 1 .432-1.175h2.001l.708-1.987a.666.666 0 0 1 1.25 0l.708 1.987h2.001a.666.666 0 0 1 .428 1.177M8.236 3.595l1.585 1.29-.627 2.011a.668.668 0 0 0 1.007.754l1.805-1.208 1.836 1.196a.668.668 0 0 0 .997-.769l-.652-1.987 1.577-1.285a.668.668 0 0 0-.429-1.177h-2.001L12.626.433a.666.666 0 0 0-1.25 0l-.708 1.987H8.667a.666.666 0 0 0-.432 1.175zm-2.394 7.042a.668.668 0 0 0 .997-.769l-.652-1.987 1.577-1.285a.668.668 0 0 0-.429-1.177H5.334l-.708-1.987a.666.666 0 0 0-1.25 0l-.708 1.987H.667a.666.666 0 0 0-.432 1.175l1.585 1.29-.627 2.011a.668.668 0 0 0 1.007.754l1.805-1.208zm14.1 6.951-.639 3.196A4 4 0 0 1 15.381 24H7a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1.456l2.193-4.149c.18-.352.428-.614.682-.719q.32-.132.64-.132c.682 0 1.244.446 1.432 1.136.022.08.05.265-.007.599L12.816 14h4.183a3 3 0 0 1 2.943 3.588M7.001 22h1v-6h-1c-.551 0-1 .449-1 1v4c0 .551.449 1 1 1m10.772-5.634A.99.99 0 0 0 17 16h-6.999v6h5.379c.95 0 1.775-.676 1.961-1.608l.639-3.196a.99.99 0 0 0-.207-.83"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-feedback-review_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFeedbackReview;
